import { useEffect, useState } from "react";
import verifySession from "../../../utils/verifySession";
import Dashboard from "./components/Dashboard/Dashboard";

function AdminPage() {
    const [okSession, setOkSession] = useState(false);
    const [loading, setLoading] = useState(true);
    

    useEffect(() => {
        const session = async () => {
            const verify = await verifySession();
            console.log(verify)
            if (verify.message == 'OK') {
                setOkSession(!okSession);
                setLoading(!loading);
            }
            return verify;
        }
        session();
    }, []);

    return (
        <div className="Admin-Page">
            {
                loading ? <div>
                    <span>Verificando...</span>
                </div> : okSession ? <div>
                    <Dashboard />
                </div> : <div>
                    <span>No has iniciado session</span>
                </div>
            }
        </div>
    );
}

export default AdminPage;